import { features } from '@kdcloudjs/table';

function useColumnDrag(pipeline, columnDrag) {
  if (columnDrag) {
    pipeline.use(features.columnDrag(columnDrag === true ? {} : columnDrag));
  }
}

export default useColumnDrag;